import { Component } from '@angular/core';

@Component({
  selector: 'app-question-bank',
  templateUrl: './question-bank.component.html',
  styleUrls: ['./question-bank.component.scss']
})
export class QuestionBankComponent {

  oddOpen2025_26 = false;
  evenOpen2025_26 = false;
  evenOpen = false;
  oddOpen = false;

  oddStreams2025_26 = [
    {
        "name": "B.A",
        "open": false,
        "papers": [
            {
                "title": "B.A. (SEC) E-Governance, Computer Applications in Businesss Management, Event Management",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. (SEC) E-Governance, Computer Applications in Businesss Management, Event Management.pdf"
            },
            {
                "title": "B.A. Economics (Semesters I, III, V) DSC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. Economics (Semesters I, III, V) DSC.pdf"
            },
            {
                "title": "B.A. English (Semesters I, III, V) DSC, MIC & AEC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. English (Semesters I, III, V) DSC, MIC & AEC.pdf"
            },
            {
                "title": "B.A. Geography (Semesters I, III, V) MIC and DSC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. Geography (Semesters I, III, V) MIC and DSC.pdf"
            },
            {
                "title": "B.A. Hindi (Semesters I, III, V)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. Hindi (Semesters I, III, V).pdf"
            },
            {
                "title": "B.A. History (Semesters I, III, V) DSC and MDC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. History (Semesters I, III, V) DSC and MDC.pdf"
            },
            {
                "title": "B.A. Home Science (Semesters I, III, V) DSC and MDC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. Home Science (Semesters I, III, V) DSC and MDC.pdf"
            },
            {
                "title": "B.A. Physical Education (Semesters I, III, V)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. Physical Education (Semesters I, III, V).pdf"
            },
            {
                "title": "B.A. Political Science (Semesters I, III, V) DSC and MDC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. Political Science (Semesters I, III, V) DSC and MDC.pdf"
            },
            {
                "title": "B.A. Psychology (Semesters I, III, V) DSC, MDC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. Psychology (Semesters I, III, V) DSC, MDC.pdf"
            },
            {
                "title": "B.A. Public Administration (Semesters I, III, V) DSC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. Public Administration (Semesters I, III, V) DSC.pdf"
            },
            {
                "title": "B.A. Punjabi (Semesters I, III, V) DSC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. Punjabi (Semesters I, III, V) DSC.pdf"
            },
            {
                "title": "B.A. Sanskrit (Semester III) Elective",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. Sanskrit (Semester III) Elective.pdf"
            },
            {
                "title": "B.A. Sociology  (Semester V)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. Sociology  (Semester V).pdf"
            },
            {
                "title": "B.A. Value Added Courses (VAC)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.A. Value Added Courses (VAC).pdf"
            },
            {
                "title": "B.Sc  & B.A. (Semester III) DSC & MIC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.Sc  & B.A. (Semester III) DSC & MIC.pdf"
            },
            {
                "title": "B.Sc. &  B.A. (Semester I) DSC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.Sc. &  B.A. (Semester I) DSC.pdf"
            },
            {
                "title": "B.Sc. & B.A.  (Semester V)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A/B.Sc. & B.A.  (Semester V).pdf"
            }
        ]
    },
    {
        "name": "B.A.J.M.C",
        "open": false,
        "papers": [
            {
                "title": "B.A.J.M.C (Semester I) AEC ,SEC & DSC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A.J.M.C/B.A.J.M.C (Semester I) AEC ,SEC & DSC.pdf"
            },
            {
                "title": "B.A.J.M.C (Semester III) MDC & DSC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A.J.M.C/B.A.J.M.C (Semester III) MDC & DSC.pdf"
            },
            {
                "title": "B.A.J.M.C (Semester V)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.A.J.M.C/B.A.J.M.C (Semester V).pdf"
            }
        ]
    },
    {
        "name": "B.B.A",
        "open": false,
        "papers": [
            {
                "title": "B.B.A. (Semester I) DSC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.B.A/B.B.A. (Semester I) DSC.pdf"
            },
            {
                "title": "B.B.A. (Semester III) MDC, MIC & DSC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.B.A/B.B.A. (Semester III) MDC, MIC & DSC.pdf"
            },
            {
                "title": "B.B.A. (Semester V)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.B.A/B.B.A. (Semester V).pdf"
            }
        ]
    },
    {
        "name": "B.C.A",
        "open": false,
        "papers": [
            {
                "title": "B.C.A. (Semester I) MIC & DSC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.C.A/B.C.A. (Semester I) MIC & DSC.pdf"
            },
            {
                "title": "B.C.A. (Semester III) MIC & DSC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.C.A/B.C.A. (Semester III) MIC & DSC.pdf"
            },
            {
                "title": "B.C.A. (Semester V)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.C.A/B.C.A. (Semester V).pdf"
            }
        ]
    },
    {
        "name": "B.Com",
        "open": false,
        "papers": [
            {
                "title": "B.Com. (Semester I) DSC & MIC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.Com/B.Com. (Semester I) DSC & MIC.pdf"
            },
            {
                "title": "B.Com. (Semester III) DSC , MIC & MDC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.Com/B.Com. (Semester III) DSC , MIC & MDC.pdf"
            },
            {
                "title": "B.Com. (Semester V)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.Com/B.Com. (Semester V).pdf"
            }
        ]
    },
    {
        "name": "B.P.Ed",
        "open": false,
        "papers": [
            {
                "title": "B.P.Ed. (Semester I)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.P.Ed/B.P.Ed. (Semester I).pdf"
            },
            {
                "title": "B.P.Ed. (Semester III)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.P.Ed/B.P.Ed. (Semester III).pdf"
            }
        ]
    },
    {
        "name": "B.Sc",
        "open": false,
        "papers": [
            {
                "title": "B.Sc  & B.A. (Semester III) DSC & MIC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.Sc/B.Sc  & B.A. (Semester III) DSC & MIC.pdf"
            },
            {
                "title": "B.Sc. (Semester I) Physical Science",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.Sc/B.Sc. (Semester I) Physical Science.pdf"
            },
            {
                "title": "B.Sc. &  B.A. (Semester I) DSC",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.Sc/B.Sc. &  B.A. (Semester I) DSC.pdf"
            },
            {
                "title": "B.Sc. & B.A.  (Semester V)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/B.Sc/B.Sc. & B.A.  (Semester V).pdf"
            }
        ]
    },
    {
        "name": "D.P.Ed",
        "open": false,
        "papers": [
            {
                "title": "D.P.Ed. (Semester I)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/D.P.Ed/D.P.Ed. (Semester I).pdf"
            },
            {
                "title": "D.P.Ed. (Semester III)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/D.P.Ed/D.P.Ed. (Semester III).pdf"
            }
        ]
    },
    {
        "name": "M.A. English",
        "open": false,
        "papers": [
            {
                "title": "M.A. English (Semester I)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/M.A. English/M.A. English (Semester I).pdf"
            },
            {
                "title": "M.A. English (Semester III)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/M.A. English/M.A. English (Semester III).pdf"
            }
        ]
    },
    {
        "name": "M.A. Hindi",
        "open": false,
        "papers": [
            {
                "title": "M.A. Hindi (Semester I)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/M.A. Hindi/M.A. Hindi (Semester I).pdf"
            },
            {
                "title": "M.A. Hindi (Semester III)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/M.A. Hindi/M.A. Hindi (Semester III).pdf"
            }
        ]
    },
    {
        "name": "M.A. Public Administration",
        "open": false,
        "papers": [
            {
                "title": "M.A. Public Administration (Semester I)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/M.A. Public Administration/M.A. Public Administration (Semester I).pdf"
            },
            {
                "title": "M.A. Public Administration (Semester III)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/M.A. Public Administration/M.A. Public Administration (Semester III).pdf"
            }
        ]
    },
    {
        "name": "M.Com",
        "open": false,
        "papers": [
            {
                "title": "M.Com (Semester I)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/M.Com/M.Com (Semester I).pdf"
            },
            {
                "title": "M.Com (Semester III)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/M.Com/M.Com (Semester III).pdf"
            }
        ]
    },
    {
        "name": "M.Sc. Mathematics",
        "open": false,
        "papers": [
            {
                "title": "M.Sc. Mathematics (Semester I)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/M.Sc. Mathematics/M.Sc. Mathematics (Semester I).pdf"
            },
            {
                "title": "M.Sc. Mathematics (Semester III)",
                "url": "assets/pdf/Question Papers 2025-26, Odd Semester/M.Sc. Mathematics/M.Sc. Mathematics (Semester III).pdf"
            }
        ]
    }
];

  evenStreams2025_26 = [
    {
        "name": "B.A",
        "open": false,
        "papers": [
            {
                "title": "B.A. (Public Administration) Open Elective",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. (Public Administration) Open Elective.pdf"
            },
            {
                "title": "B.A. & B.Sc. (Semester II) Mathematics , Chemistry, Physics, Computer Science",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. & B.Sc. (Semester II) Mathematics , Chemistry, Physics, Computer Science.pdf"
            },
            {
                "title": "B.A. & B.Sc. (Semester IV) Chemistry, Physics, Computer science, Mathematics",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. & B.Sc. (Semester IV) Chemistry, Physics, Computer science, Mathematics.pdf"
            },
            {
                "title": "B.A. Economics (Semesters II, IV, VI) DSC",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Economics (Semesters II, IV, VI) DSC.pdf"
            },
            {
                "title": "B.A. English (Semesters II, IV, VI) DSC, MIC, SEC, AEC",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. English (Semesters II, IV, VI) DSC, MIC, SEC, AEC.pdf"
            },
            {
                "title": "B.A. Environmental Studies (Semesters I, II, III, IV, V, VI) 28-Aug-2026 19-00-26",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Environmental Studies (Semesters I, II, III, IV, V, VI) 28-Aug-2026 19-00-26.pdf"
            },
            {
                "title": "B.A. Geography (Semesters II, IV, VI)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Geography (Semesters II, IV, VI).pdf"
            },
            {
                "title": "B.A. Hindi (Semesters II, IV, VI) AEC, DSC & MIC",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Hindi (Semesters II, IV, VI) AEC, DSC & MIC.pdf"
            },
            {
                "title": "B.A. History (Semesters II, IV, VI) DSC",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. History (Semesters II, IV, VI) DSC.pdf"
            },
            {
                "title": "B.A. Home Science (Semesters II, IV, VI)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Home Science (Semesters II, IV, VI).pdf"
            },
            {
                "title": "B.A. Physical Education (Semesters VI)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Physical Education (Semesters VI).pdf"
            },
            {
                "title": "B.A. Political Science (Open Elective)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Political Science (Open Elective).pdf"
            },
            {
                "title": "B.A. Political Science (Semesters II, IV, VI) DSC",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Political Science (Semesters II, IV, VI) DSC.pdf"
            },
            {
                "title": "B.A. Psychology (Semesters II, IV, VI), SEC,DSC,MDC",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Psychology (Semesters II, IV, VI), SEC,DSC,MDC.pdf"
            },
            {
                "title": "B.A. Public Administration (Semesters II, IV, VI)DSC",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Public Administration (Semesters II, IV, VI)DSC.pdf"
            },
            {
                "title": "B.A. Punjabi (Semesters II, IV, VI) DSC",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Punjabi (Semesters II, IV, VI) DSC.pdf"
            },
            {
                "title": "B.A. Sanskrit (Semester IV)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Sanskrit (Semester IV).pdf"
            },
            {
                "title": "B.A. Skill Enhancement Courses",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Skill Enhancement Courses.pdf"
            },
            {
                "title": "B.A. Sociology (Semesters II, IV, VI)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Sociology (Semesters II, IV, VI).pdf"
            },
            {
                "title": "B.A. Value Added Courses",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A/B.A. Value Added Courses.pdf"
            }
        ]
    },
    {
        "name": "B.A.J.M.C",
        "open": false,
        "papers": [
            {
                "title": "B.A.J.M.C (Semester II)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A.J.M.C/B.A.J.M.C (Semester II).pdf"
            },
            {
                "title": "B.A.J.M.C (Semester IV)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A.J.M.C/B.A.J.M.C (Semester IV).pdf"
            },
            {
                "title": "B.A.J.M.C (Semester VI)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.A.J.M.C/B.A.J.M.C (Semester VI).pdf"
            }
        ]
    },
    {
        "name": "B.B.A",
        "open": false,
        "papers": [
            {
                "title": "B.B.A. (Semester II)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.B.A/B.B.A. (Semester II).pdf"
            },
            {
                "title": "B.B.A. (Semester IV)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.B.A/B.B.A. (Semester IV).pdf"
            },
            {
                "title": "B.B.A. (Semester VI)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.B.A/B.B.A. (Semester VI).pdf"
            }
        ]
    },
    {
        "name": "B.C.A",
        "open": false,
        "papers": [
            {
                "title": "B.C.A. (Semester II)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.C.A/B.C.A. (Semester II).pdf"
            },
            {
                "title": "B.C.A. (Semester IV)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.C.A/B.C.A. (Semester IV).pdf"
            },
            {
                "title": "B.C.A. (Semester VI)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.C.A/B.C.A. (Semester VI).pdf"
            }
        ]
    },
    {
        "name": "B.Com",
        "open": false,
        "papers": [
            {
                "title": "B.Com. (Semester II)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.Com/B.Com. (Semester II).pdf"
            },
            {
                "title": "B.Com. (Semester IV)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.Com/B.Com. (Semester IV).pdf"
            },
            {
                "title": "B.Com. (Semester VI)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.Com/B.Com. (Semester VI).pdf"
            }
        ]
    },
    {
        "name": "B.P.Ed",
        "open": false,
        "papers": [
            {
                "title": "B.P.Ed. (Semester II)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.P.Ed/B.P.Ed. (Semester II).pdf"
            },
            {
                "title": "B.P.Ed. (Semester IV)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.P.Ed/B.P.Ed. (Semester IV).pdf"
            }
        ]
    },
    {
        "name": "B.Sc. Physical Sciences",
        "open": false,
        "papers": [
            {
                "title": "B.A. & B.Sc. (Semester II) Mathematics , Chemistry, Physics, Computer Science",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.Sc. Physical Sciences/B.A. & B.Sc. (Semester II) Mathematics , Chemistry, Physics, Computer Science.pdf"
            },
            {
                "title": "B.A. & B.Sc. (Semester IV) Chemistry, Physics, Computer science, Mathematics",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.Sc. Physical Sciences/B.A. & B.Sc. (Semester IV) Chemistry, Physics, Computer science, Mathematics.pdf"
            }
        ]
    },
    {
        "name": "B.Sc. Physical, Health and Sports Education",
        "open": false,
        "papers": [
            {
                "title": "B.Sc. Physical, Health and Sports Education (Semester II)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/B.Sc. Physical, Health and Sports Education/B.Sc. Physical, Health and Sports Education (Semester II).pdf"
            }
        ]
    },
    {
        "name": "D.P.Ed",
        "open": false,
        "papers": [
            {
                "title": "D.P.Ed. (Semester II)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/D.P.Ed/D.P.Ed. (Semester II).pdf"
            },
            {
                "title": "D.P.Ed. (Semester IV)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/D.P.Ed/D.P.Ed. (Semester IV).pdf"
            }
        ]
    },
    {
        "name": "M.A. English",
        "open": false,
        "papers": [
            {
                "title": "M.A. English (Semester II)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/M.A. English/M.A. English (Semester II).pdf"
            },
            {
                "title": "M.A. English (Semester IV)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/M.A. English/M.A. English (Semester IV).pdf"
            }
        ]
    },
    {
        "name": "M.A. Hindi",
        "open": false,
        "papers": [
            {
                "title": "M.A. Hindi (Semester II)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/M.A. Hindi/M.A. Hindi (Semester II).pdf"
            },
            {
                "title": "M.A. Hindi (Semester IV)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/M.A. Hindi/M.A. Hindi (Semester IV).pdf"
            }
        ]
    },
    {
        "name": "M.A. Public Administration",
        "open": false,
        "papers": [
            {
                "title": "M.A. Public Administration (Semester II)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/M.A. Public Administration/M.A. Public Administration (Semester II).pdf"
            },
            {
                "title": "M.A. Public Administration (Semester IV)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/M.A. Public Administration/M.A. Public Administration (Semester IV).pdf"
            }
        ]
    },
    {
        "name": "M.Com",
        "open": false,
        "papers": [
            {
                "title": "M.Com. (Semester II)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/M.Com/M.Com. (Semester II).pdf"
            },
            {
                "title": "M.Com. (Semester IV)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/M.Com/M.Com. (Semester IV).pdf"
            }
        ]
    },
    {
        "name": "M.Sc. Mathematics",
        "open": false,
        "papers": [
            {
                "title": "M.Sc. Mathematics (Semester II)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/M.Sc. Mathematics/M.Sc. Mathematics (Semester II).pdf"
            },
            {
                "title": "M.Sc. Mathematics (Semester IV)",
                "url": "assets/pdf/Question Papers 2025-26, Even Semester/M.Sc. Mathematics/M.Sc. Mathematics (Semester IV).pdf"
            }
        ]
    }
];

  evenStreams = [
    {
      name: 'B.A.',
      open: false,
      papers: [
  {
    title: 'B.A. & B.Sc. (Semester II) Mathematics & Basic Computer Course',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. & B.Sc. (Semester II) Mathematics & Basic Computer Course.pdf'
  },
   {
    title: 'B.A. & B.Sc. (Semester IV) Mathematics, Database Management Systems, Software Engineering',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. & B.Sc. (Semester IV) Mathematics, Database Management Systems, Software Engineering.pdf'
  },
   {
    title: 'B.A. & B.Sc. (Semester VI) Mathematics, AI, Introduction to Linux',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. & B.Sc. (Semester VI) Mathematics, AI, Introduction to Linux.pdf'
  },
   {
    title: 'B.A. Economics (Semesters II, IV, VI)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. Economics (Semesters II, IV, VI).pdf'
  },
   {
    title: 'B.A. English (Semesters II, IV, VI) DSC & AEC',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. English (Semesters II, IV, VI) DSC & AEC.pdf'
  },
   {
    title: 'B.A. Geography (Semesters II, IV, VI)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. Geography (Semesters II, IV, VI).pdf'
  },
   {
    title: 'B.A. Hindi (Semesters II, IV, VI) AEC, DSC & MIC',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. Hindi (Semesters II, IV, VI) AEC, DSC & MIC.pdf'
  },
   {
    title: 'B.A. History (Semesters II, IV, VI)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. History (Semesters II, IV, VI).pdf'
  },
   {
    title: 'B.A. Home Science (Semesters II, IV, VI)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. Home Science (Semesters II, IV, VI).pdf'
  },
   {
    title: 'B.A. Physical Education (Semesters II, IV, VI)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. Physical Education (Semesters II, IV, VI).pdf'
  },
   {
    title: 'B.A. Political Science (Semesters II, IV, VI)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. Political Science (Semesters II, IV, VI).pdf'
  },
   {
    title: 'B.A. Psychology (Semesters II, IV, VI), SEC (Developing Life Skills)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. Psychology (Semesters II, IV, VI), SEC (Developing Life Skills).pdf'
  },
   {
    title: 'B.A. Public Administration (Semesters II, IV, VI)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. Public Administration (Semesters II, IV, VI).pdf'
  },
   {
    title: 'B.A. Punjabi (Semesters II, IV, VI)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. Punjabi (Semesters II, IV, VI).pdf'
  },
   {
    title: 'B.A. Sanskrit (Semester II)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.A/B.A. Sanskrit (Semester II).pdf'
  }
]
    },
    {
      name: 'B.B.A.',
      open: false,
      papers: [
        {
    title: 'B.B.A. (Semester II)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.B.A/B.B.A. (Semester II).pdf'
  },{
    title: 'B.B.A. (Semester IV)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.B.A/B.B.A. (Semester IV).pdf'
  },{
    title: 'B.B.A. (Semester VI)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.B.A/B.B.A. (Semester VI).pdf'
  }
      ]
    },
    {
      name: 'B.C.A.',
      open: false,
      papers: [
        {
    title: 'B.C.A. (Semester II)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.C.A/B.C.A. (Semester II).pdf'
  },{
    title: 'B.C.A. (Semester IV)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.C.A/B.C.A. (Semester IV).pdf'
  },{
    title: 'B.C.A. (Semester VI)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.C.A/B.C.A. (Semester VI).pdf'
  }
      ]
    },
    {
      name: 'B.Com.',
      open: false,
      papers: [
         {
    title: 'B.Com. (Semester II)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.Com/B.Com. (Semester II).pdf'
  },{
    title: 'B.Com. (Semester IV)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.Com/B.Com. (Semester IV).pdf'
  },{
    title: 'B.Com. (Semester VI)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.Com/B.Com. (Semester VI).pdf'
  }
      ]
    },
    {
      name: 'B.P.Ed.',
      open: false,
      papers: [
        {
    title: 'B.P.Ed. (Semester II)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.P.Ed/B.P.Ed. (Semester II).pdf'
  },{
    title: 'B.P.Ed. (Semester IV)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.P.Ed/B.P.Ed. (Semester IV).pdf'
  }
      ]
    },
    {
      name: 'B.Sc.',
      open: false,
      papers: [
         {
    title: 'B.A. & B.Sc. (Semester II) Mathematics & Basic Computer Course',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.Sc/B.A. & B.Sc. (Semester II) Mathematics & Basic Computer Course.pdf'
  },{
    title: 'B.A. & B.Sc. (Semester IV) Mathematics, Database Management Systems, Software Engineering',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.Sc/B.A. & B.Sc. (Semester IV) Mathematics, Database Management Systems, Software Engineering.pdf'
  },{
    title: 'B.A. & B.Sc. (Semester VI) Mathematics, AI, Introduction to Linux',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.Sc/B.A. & B.Sc. (Semester VI) Mathematics, AI, Introduction to Linux.pdf'
  }, {
    title: 'B.Sc. (Semester II)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.Sc/B.Sc. (Semester II).pdf'
  },{
    title: 'B.Sc. (Semester IV)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.Sc/B.Sc. (Semester IV).pdf'
  },{
    title: 'B.Sc. (Semester VI)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/B.Sc/B.Sc. (Semester VI).pdf'
  }
      ]
    },
    {
      name: 'D.P.Ed.',
      open: false,
      papers: [
         {
    title: 'D.P.Ed. (Semester II)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/D.P.Ed/D.P.Ed. (Semester II).pdf'
  },{
    title: 'D.P.Ed. (Semester IV)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/D.P.Ed/D.P.Ed. (Semester IV).pdf'
  }
      ]
    },
    {
      name: 'M.A. English',
      open: false,
      papers: [
         {
    title: 'M.A. English (Semester II)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/M.A. English/M.A. English (Semester II).pdf'
  },{
    title: 'M.A. English (Semester IV)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/M.A. English/M.A. English (Semester IV).pdf'
  }
      ]
    },
    {
      name: 'M.A. Hindi',
      open: false,
      papers: [
         {
    title: 'M.A. Hindi (Semester II)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/M.A. Hindi/M.A. Hindi (Semester II).pdf'
  },{
    title: 'M.A. Hindi (Semester IV)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/M.A. Hindi/M.A. Hindi (Semester IV).pdf'
  }
      ]
    },
    {
      name: 'M.Com.',
      open: false,
      papers: [
         {
    title: 'M.Com. (Semester II)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/M.Com/M.Com. (Semester II).pdf'
  },{
    title: 'M.Com. (Semester IV)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/M.Com/M.Com. (Semester IV).pdf'
  }
      ]
      
    },
    {
      name: 'M.Sc. Mathematics',
      open: false,
      papers: [
         {
    title: 'M.Sc. Mathematics (Semester II)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/M.Sc. Mathematics/M.Sc. Mathematics (Semester II).pdf'
  },{
    title: 'M.Sc. Mathematics (Semester IV)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Even Sem/M.Sc. Mathematics/M.Sc. Mathematics (Semester IV).pdf'
  }
      ]
    }
  ];

  oddStreams = [
    {
      name: 'B.A.',
      open: false,
      papers: [
        {
    title: 'B.A Sociology SEC & MDC',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A Sociology SEC & MDC.pdf'
  },{
    title: 'B.A. Economics (Semesters I, III, V)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Economics (Semesters I, III, V).pdf'
  },{
    title: 'B.A. English (Semesters I, III, V) DSC & AEC',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. English (Semesters I, III, V) DSC & AEC.pdf'
  },{
    title: 'B.A. Environmental Studies (Semesters I, II, III, IV, V & VI) UG Compulsory & VAC',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Environmental Studies (Semesters I, II, III, IV, V & VI) UG Compulsory & VAC.pdf'
  },{
    title: 'B.A. Geography (Semesters I, III, V)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Geography (Semesters I, III, V).pdf'
  },{
    title: 'B.A. Hindi (Semesters I, III, V)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Hindi (Semesters I, III, V).pdf'
  },{
    title: 'B.A. History (Semesters I, III, V)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. History (Semesters I, III, V).pdf'
  },{
    title: 'B.A. Home Science (Semesters I, III, V)  DSC and MDC',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Home Science (Semesters I, III, V)  DSC and MDC.pdf'
  },{
    title: 'B.A. Physical Education (Semesters I, III, V)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Physical Education (Semesters I, III, V).pdf'
  },{
    title: 'B.A. Political Science (Semesters I, III, V) DSC and MDC',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Political Science (Semesters I, III, V) DSC and MDC.pdf'
  },{
    title: 'B.A. Psychology (Semesters I, III, V) DSC, MDC & SEC',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Psychology (Semesters I, III, V) DSC, MDC & SEC.pdf'
  },{
    title: 'B.A. Public Administration (Semesters I, III, V)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Public Administration (Semesters I, III, V).pdf'
  },{
    title: 'B.A. Punjabi (Semesters I, III, V) DSC & SEC',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Punjabi (Semesters I, III, V) DSC & SEC.pdf'
  },{
    title: 'B.A. Sanskrit (Semester III) Elective',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Sanskrit (Semester III) Elective.pdf'
  },{
    title: 'B.A. Sociology',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Sociology (Semesters I, III, V).pdf'
  },{
    title: 'B.A. Universal Human Values (VAC) 104',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A/B.A. Universal Human Values (VAC) 104.pdf'
  }
      ]
    },
    {
      name: 'B.A.J.M.C.',
      open: false,
      papers: [
        {
    title: 'B.A.J.M.C (Semester I)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A.J.M.C/B.A.J.M.C (Semester I).pdf'
  },{
    title: 'B.A.J.M.C (Semester III)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A.J.M.C/B.A.J.M.C (Semester III).pdf'
  },{
    title: 'B.A.J.M.C. (Semester V)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.A.J.M.C/B.A.J.M.C. (Semester V).pdf'
  }
      ]
    },
    {
      name: 'B.B.A.',
      open: false,
      papers: [
         {
    title: 'B.B.A. (Semester I)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.B.A/B.B.A. (Semester I).pdf'
  },{
    title: 'B.B.A. (Semester III)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.B.A/B.B.A. (Semester III).pdf'
  },{
    title: 'B.B.A. (Semester V)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.B.A/B.B.A. (Semester V).pdf'
  }
      ]
    },
    {
      name: 'B.C.A.',
      open: false,
      papers: [
         {
    title: 'B.C.A. (Semester I)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.C.A/B.C.A. (Semester I).pdf'
  },{
    title: 'B.C.A. (Semester III)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.C.A/B.C.A. (Semester III).pdf'
  },{
    title: 'B.C.A. (Semester V)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.C.A/B.C.A. (Semester V).pdf'
  }
      ]
    },
    {
      name: 'B.Com.',
      open: false,
      papers: [
         {
    title: 'B.Com (Semester III)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.Com/B.Com (Semester III).pdf'
  },{
    title: 'B.Com. (Semester I)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.Com/B.Com. (Semester I).pdf'
  },{
    title: 'B.Com. (Semester V)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.Com/B.Com. (Semester V).pdf'
  }
      ]
    },
    {
      name: 'B.P.Ed.',
      open: false,
      papers: [
        {
    title: 'B.P.Ed. (Semester I)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.P.Ed/B.P.Ed. (Semester I).pdf'
  },{
    title: 'B.P.Ed. (Semester III)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.P.Ed/B.P.Ed. (Semester III).pdf'
  }
      ]
    },
    {
      name: 'B.Sc.',
      open: false,
      papers: [
         {
    title: 'B.Sc. (Semester I)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.Sc/B.Sc. (Semester I).pdf'
  },{
    title: 'B.Sc. (Semester III)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.Sc/B.Sc. (Semester III).pdf'
  },{
    title: 'B.Sc. (Semester V)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/B.Sc/B.Sc. (Semester V).pdf'
  }
      ]
    },
    {
      name: 'D.P.Ed.',
      open: false,
      papers: [
        {
    title: 'D.P.Ed. (Semester I)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/D.P.Ed/D.P.Ed. (Semester I).pdf'
  },{
    title: 'D.P.Ed. (Semester III)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/D.P.Ed/D.P.Ed. (Semester III).pdf'
  }
      ]
    },
    {
      name: 'M.A. English',
      open: false,
      papers: [
            {
    title: 'M.A. English (Semester I)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/M.A. English/M.A. English (Semester I).pdf'
  },{
    title: 'M.A. English (Semester III)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/M.A. English/M.A. English (Semester III).pdf'
  }
      ]
    },
    {
      name: 'M.A. Hindi',
      open: false,
      papers: [
         {
    title: 'M.A. Hindi (Semester I)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/M.A. Hindi/M.A. Hindi (Semester I).pdf'
  },{
    title: 'M.A. HINDI (Semester III)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/M.A. Hindi/M.A. Hindi (Semester III).pdf'
  }
      ]
    },
    {
      name: 'M.A. Public Administration',
      open: false,
      papers: [
         {
    title: 'M.A. Public Administration (Semester I)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/M.A. Public Administration/M.A. Public Administration (Semester I).pdf'
  },{
    title: 'M.A. Public Administration (Semester III)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/M.A. Public Administration/M.A. Public Administration (Semester III).pdf'
  }
      ]
    },
    {
      name: 'M.Com.',
      open: false,
      papers: [
        {
    title: 'M.Com (Semester I)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/M.Com/M.Com (Semester I).pdf'
  }
      ]
    },
    {
      name: 'M.Sc. Mathematics',
      open: false,
      papers: [
        {
    title: 'M.Sc. Mathematics (Semester I)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/M.Sc. Mathematics/M.Sc. Mathematics (Semester I).pdf'
  },{
    title: 'M.Sc. Mathematics (Semester III)',
    url: 'assets/pdf/Question Bank/Session 2024-25/Odd Sem/M.Sc. Mathematics/M.Sc. Mathematics (Semester III).pdf'
  }
      ]
    }
  ];

  toggleEven() {
    this.evenOpen = !this.evenOpen;
  }

  toggleOdd() {
    this.oddOpen = !this.oddOpen;
  }

  toggleOdd2025_26() {
    this.oddOpen2025_26 = !this.oddOpen2025_26;
  }

  toggleStream(stream: any) {
    stream.open = !stream.open;
  }


  toggleEven2025_26() {
    this.evenOpen2025_26 = !this.evenOpen2025_26;
  }

}